import { useTranslation } from 'react-i18next';
import { Button } from '@treezor/design-system';

import { useKycInfos } from '../../hooks/useKycInfos';

import { useAccesControl } from '@/hooks/useAccessControl';
import { useAction } from '@/hooks/useAction';

import { featuresSlugs } from '@/features/roles/store/models/features.model';
import { userStatusValues } from '@/store/models/user.swagger.model';

import { KycDocumentList } from './KycDocumentList';

export function KycDocuments() {
  const { t } = useTranslation();

  const { displayActionFromConfig } = useAction();
  const { hasAccessToFeature } = useAccesControl();
  const {
    pageTitle,
    isKycActionDisabled: isDisabled,
    isUploadDocumentLoading,
    toggleKycDocumentUploadModal,
    user,
  } = useKycInfos();

  return (
    <div className="flex flex-col gap-4 mb-6">
      <div className="flex items-center justify-between">
        <h5 className="typo-h5-bold text-secondary">{t('pages.currentProfiles.kyc.documents.title')}</h5>
        {displayActionFromConfig('addKycDocument') &&
          hasAccessToFeature(featuresSlugs.ADD_KYC_DOCUMENT) &&
          user.userStatus !== userStatusValues.CANCELED && (
            <Button
              id="add-kyc-document-btn"
              variant="tertiary"
              icon="add"
              size="s"
              onClick={toggleKycDocumentUploadModal}
              disabled={isDisabled || isUploadDocumentLoading}
            >
              {t('pages.currentProfiles.kyc.actions.addDocument', { value: pageTitle })}
            </Button>
          )}
      </div>
      <KycDocumentList />
    </div>
  );
}
